import type { Handler } from '@/types';

export const doNothingOnSubmit: Handler = e => {
  e.preventDefault();
};
